module.exports = __webpack_public_path__ + "8d152a0d49db2ee005f9b78f6332863f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/camera_placeholder.jpg
// module id = 1840
// module chunks = 0